import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGift, FaStar } from 'react-icons/fa';

const LoyaltyPoints = () => {
  const { t } = useTranslation();
  return (
    <div className="rounded-lg p-6 mb-8 text-white" style={{ background: 'linear-gradient(to right, rgb(5, 70, 37), rgb(0, 53, 21))' }}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <FaGift className="w-8 h-8 mr-4" />
          <div>
            <h3 className="text-xl font-bold">{t('restaurant.loyalty.title')}</h3>
            <p className="text-white opacity-80">{t('restaurant.loyalty.subtitle')}</p>
          </div>
        </div>
        <div className="text-right">
          <div className="flex items-center mb-2">
            <FaStar className="w-5 h-5 text-yellow-400 mr-2" />
            <span className="text-2xl font-bold">0</span>
          </div>
          <p className="text-sm text-white opacity-80">{t('restaurant.loyalty.pointsAvailable')}</p>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyPoints;